<template>
  <div v-if="canShowLGPD" style="background-color: black; width: 100%; position: fixed; z-index: 200; opacity: 90%">
      <v-layout row justify-center>
          <v-dialog :value="canShowLGPD"
          content-class="dialog-lgpd"
            persistent max-width="730" max-height="700">      
            <v-card
              style="max-height: 730px;"
            >
              <v-card-text style=" padding:20px; justify-content: center; overflow-y: auto !important; max-height: 700px; flex-direction: column; align-items: center;">
                <v-layout  column gap-xl ml-3 mt-3 mb-2 style="padding: 20px">
                  <div v-if="campaignHasOwnText" class="lgpd-campaign-text" v-html="termText"></div>
                  <h2 v-else v-html="termText" style="margin: 0; text-align: center;"></h2>
                </v-layout>

              </v-card-text>
              <v-card-actions class="pa-0 p-2">
                <div class="footer-modal-atividades" style="justify-content: space-between !important;">
                  <!-- Negativa a esquerda, afirmativa a direita. -->
                  <v-radio
                      :label="declineLabel"
                      @change="openDeclineLGPD"
                    ></v-radio>
                  <v-radio
                      :label="acceptLabel"
                      @change="showLGPDTermModal"
                    ></v-radio>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>

        <LGPDTerm :dialog="showLGPDTerm" @close="closeLGPD"/>

        <AucAlert
          ref="declineLGPDRef"
          title="Você confirma que NÃO autoriza?"
          confirmButtonText="Sim"
          cancelButtonText="Não"
          @confirm="decline"
        />
        <AucAlert
          ref="acceptLGPDRef"
          title="Você confirma que autoriza?"
          confirmButtonText="Sim"
          cancelButtonText="Não"
          @confirm="accept"
        />
  </div>
</template>

<script type="plain/text">

// Services
import CampaignService from "@/scripts/services/campaign.service";
import UserCompanyConsentTermService from "@/scripts/services/userCompanyConsentTerm.service";

// Models
import UserCompanyConsentTerm from "../scripts/models/userCompanyConsentTerm.model";

//Components
import AucAlert from "@/components/AucAlert.vue";
import LGPDTerm from "@/components/LGPDTerm.vue";

//VUEX
import { mapGetters, mapActions } from "vuex";


export default {
  props: ['dialog'],
  components: {
    AucAlert,
    LGPDTerm
  },
  data() {
    return {
      campaignService: new CampaignService(),
      userCompanyConsentTermService: new UserCompanyConsentTermService(),
      userCompanyConsentTerm: new UserCompanyConsentTerm(),
      showLGPD: false,
      accepted: false,
      acceptedLGPDTerm: false,
      showLGPDTerm: false,
    };
  },
  watch: {
    // immediate: tambem cobre o reload de pagina que alguns fluxos de login fazem.
    logged: {
      immediate: true,
      handler(val) {
        if (val) {
          this.detectLGPD();
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      'logged',
      'userProfile',
      'campaignLandingPageConfig',
      'showPersonInfo',
    ]),
    // A modal de confirmacao de dados abre primeiro; a LGPD so depois que ela for concluida.
    canShowLGPD() {
      return this.showLGPD && !this.showPersonInfo;
    },
    campaign() {
      return this.campaignLandingPageConfig && this.campaignLandingPageConfig.campaign;
    },
    // Mesma regra do back (CampaignBusiness.HasOwnLGPDText): texto e aceite passam a ser da campanha.
    campaignHasOwnText() {
      return !!(this.campaign && this.campaign.enableLGPD && this.campaign.lgpdText && this.campaign.lgpdText.trim());
    },
    // Textos das opcoes: os da campanha quando ela tem LGPD propria.
    acceptLabel() {
      return (this.campaignHasOwnText && this.campaign.lgpdAcceptText && this.campaign.lgpdAcceptText.trim()) || 'Sim, autorizo.';
    },
    declineLabel() {
      return (this.campaignHasOwnText && this.campaign.lgpdDeclineText && this.campaign.lgpdDeclineText.trim()) || 'Não autorizo.';
    },
    termText() {
      if (this.campaignHasOwnText) return this.campaign.lgpdText;
      return this.campaign && this.campaign.company && this.campaign.company.lgpdText ?
        this.campaign.company.lgpdText : 'Deseja receber comunicações futuras desta organização?';
    }
  },
  created() {
    this.setLandingPageConfig();
  },
  methods: {
    ...mapActions([
      'setLandingPageConfig'
    ]),
    closeLGPD() {
      this.showLGPDTerm = false;
      this.openAcceptLGPD();
    },
    async detectLGPD() {
      this.showLGPD = await this.campaignService.showLGPD();
    },
    showLGPDTermModal() {
      if (this.campaignLandingPageConfig && this.campaignLandingPageConfig.campaign.id == 737) {
        this.showLGPDTerm = true;
      } else {
        this.openAcceptLGPD();
      }
    },
    // Campanha com LGPD propria pode dispensar o "Você confirma...?": a escolha grava direto.
    skipConfirmation() {
      return this.campaignHasOwnText && !!this.campaign.lgpdSkipConfirmation;
    },
    openAcceptLGPD() {
      if (this.skipConfirmation()) return this.accept();
      this.$refs.acceptLGPDRef.open();
    },
    openDeclineLGPD() {
      if (this.skipConfirmation()) return this.decline();
      this.$refs.declineLGPDRef.open();
    },
    accept() {
      this.accepted = true;
      this.save();
    },
    decline() {
      this.save();
    },
  async save() {
        this.userCompanyConsentTerm.userId = this.userProfile.userId;
        this.userCompanyConsentTerm.companyId = this.campaignLandingPageConfig.campaign.company.id
        this.userCompanyConsentTerm.campaignId = this.campaignHasOwnText ? this.campaign.id : null;
        this.userCompanyConsentTerm.ipAddress = await this.getIP();
        this.userCompanyConsentTerm.accepted = this.accepted;

        this.userCompanyConsentTermService.save(this.userCompanyConsentTerm)
          .then((response) => {
            this.showLGPD = false;
          })
    },
    async getIP() {
      try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
      } catch (error) {
        console.error('Erro ao buscar o IP:', error);
        return null
      }
    },
  },
}
</script>

<style scoped>
.lgpd-campaign-text {
  text-align: left;
  word-break: break-word;
}
</style>